module.exports = require("json-merge-patch");